
import { $, $$ } from '@/utilities/helpers';
import Swiper from 'swiper/bundle';
import { Howl } from 'howler';
import 'swiper/css/bundle';
/*------------------------------------------------------------------ 
Import styles
------------------------------------------------------------------*/
import Swal from 'sweetalert2/dist/sweetalert2.js';

window.Toast = Swal.mixin({
    toast: true,
    position: 'center',
    iconColor: 'white',
    customClass: { popup: 'toaster' },
    showConfirmButton: false,
    timer: 700,
    timerProgressBar: true,
});

import '../styles/main.scss';

import Game from '@/game/game';
import Predict from '@/game/predict';

import '@/prizes';

window._game = null;
window._predict = null;


let $showAdvert = $$('.js-show-advert');

const ADVERT_VIDEO_EXTENSIONS = ['mp4', 'webm', 'ogg'];

// const ADVERTS = [
//     '_resources/themes/mercury/dist/ggg_advert.mp4',
//     '_resources/themes/mercury/dist/ggg_advert.mp4',
// ];
const ADVERTS = [
    {
        src: '_resources/themes/mercury/dist/images/standard/club_kickback_advert.jpg',
        link: 'https://www.ajg.co.nz/clubkickback',
    },
    {
        src: '_resources/themes/mercury/dist/images/standard/spark_business_advert.png',
        link: 'https://www.spark.co.nz/business',
    },
];

const ADVERT_STORAGE_KEY = 'last_advert_index';

function getAdvertType(src) {
    const extension = src.split('.').pop().toLowerCase();
    return ADVERT_VIDEO_EXTENSIONS.includes(extension) ? 'video' : 'image';
}

function getNextAdvert() {
    let lastIndex = -1;
    try {
        lastIndex = parseInt(window.localStorage.getItem(ADVERT_STORAGE_KEY), 10);
    } catch (err) {
        lastIndex = -1;
    }
    if (isNaN(lastIndex)) {
        lastIndex = -1;
    }
    const nextIndex = (lastIndex + 1) % ADVERTS.length;
    try {
        window.localStorage.setItem(ADVERT_STORAGE_KEY, nextIndex);
    } catch (err) {
        // localStorage unavailable, alternation just won't persist
    }
    const { src, link } = ADVERTS[nextIndex];
    return { src, link, type: getAdvertType(src) };
}

$showAdvert.forEach((element) => {
    element.addEventListener('click', (e) => {
        e.preventDefault();
        const href = element.getAttribute('href');
        const advert = getNextAdvert();
        const advertMarkup = advert.type === 'video'
            ? `<video class="js-advert-video" autoplay muted playsinline loop>
                    <source src="${advert.src}" type="video/mp4">
                    Your browser does not support the video tag.
                </video>`
            : `<img class="js-advert-image" src="${advert.src}" alt="">`;
        Swal.fire({
            customClass: { container: 'fullSwal videoSwal' },
            html: `<a href="${advert.link}" target="_blank">
            ${advertMarkup}</a>    `,
            showCancelButton: false,
            confirmButtonText: 'Proceed',
            didOpen: () => {
                const video = document.querySelector('.js-advert-video');
                if (video) {
                    video.play().catch(err => {
                        console.warn('Autoplay failed:', err);
                    });
                }
            }
        }).then((result) => {
            if (result.isConfirmed) {
                window.location = href;
            }
        })
    });
});

if ($('.js-predict')) {
    document.addEventListener('touchmove', function (e) {
        if (window.scrollY === 0 && e.touches[0].clientY > 0) {
            e.preventDefault();
        }
    }, { passive: false });
    window._predict = new Predict(document.getElementById('game'), window.location.hash === '#debug');
}

if ($('.js-kick')) {
    document.addEventListener('touchmove', function (e) {
        if (window.scrollY === 0 && e.touches[0].clientY > 0) {
            e.preventDefault();
        }
    }, { passive: false });
    window._game = new Game(document.getElementById('game'), window.location.hash === '#debug');

}

document.addEventListener('DOMContentLoaded', () => {
    let $toggleMenu = $$('.js-toggle-menu');

    $toggleMenu.forEach((toggleMenu) => {
        toggleMenu.addEventListener('click', () => {
            document.body.classList.toggle('menu-open');

            if (document.body.classList.contains('menu-open')) {
                if (_game) _game.TIME.pause();
                if (_predict) _predict.TIME.pause();
            } else {
                if (_game) _game.TIME.resume();
                if (_predict) _predict.TIME.resume();
            }
        });
    });

    let toggleAudio = $('.js-toggle-sound');

    if (toggleAudio) {
        toggleAudio.addEventListener('click', () => {
            const isMuted = toggleAudio.classList.toggle('muted');
            if (_game) _game.SOUNDS.mute(isMuted);
            if (_predict) _predict.SOUNDS.mute(isMuted);
        });
    }

    let togglePause = $('.js-toggle-pause');

    if (togglePause) {
        togglePause.addEventListener('click', () => {
            togglePause.classList.toggle('paused');
            if (_game) _game.TIME.toggle();
            if (_predict) _predict.TIME.toggle();
        });
    }

    let resetGame = $('.js-reset-game');

    if (resetGame) {
        resetGame.addEventListener('click', () => {
            document.body.classList.remove('menu-open');
            if (_game) _game.clearState(true);
            if (_predict) _predict.clearState(true);
        });
    }

    let hideGender = $$('.js-hide-gender-slider');

    hideGender.forEach((element) => {
        element.addEventListener('click', () => {
            document.body.classList.remove('teamSliderVisible');
            document.body.classList.remove('genderSliderVisible');
        });
    })

    let hideVersus = $$('.js-hide-versus-slider');

    hideVersus.forEach((element) => {
        element.addEventListener('click', () => {
            document.body.classList.remove('teamSliderVisible');
            document.body.classList.remove('genderSliderVisible');
            document.body.classList.add('gameSliderVisible');
            document.body.classList.remove('versusSliderVisible');

        });
    })
    let hideTeam = $$('.js-hide-team-slider');

    hideTeam.forEach((element) => {
        element.addEventListener('click', () => {
            document.body.classList.remove('teamSliderVisible');
            document.body.classList.remove('genderSliderVisible');
            document.body.classList.remove('gameSliderVisible');
        });
    })

    let hideGame = $$('.js-hide-game-slider');

    hideGame.forEach((element) => {
        element.addEventListener('click', () => {
            document.body.classList.remove('teamSliderVisible');
            document.body.classList.remove('genderSliderVisible');
            document.body.classList.remove('gameSliderVisible');
        });
    })

    let chooseGender = $$('.js-show-gender-slider');

    chooseGender.forEach((element) => {
        element.addEventListener('click', () => {
            document.body.classList.remove('teamSliderVisible');
            document.body.classList.remove('gameSliderVisible');
            document.body.classList.add('genderSliderVisible');
        });
    })



    let chooseTeam = $('.js-show-team-slider');

    if (chooseTeam) {
        chooseTeam.addEventListener('click', () => {
            _game.STATE.setGender(document.querySelector('.js-slider-gender .swiper-slide-active').dataset.team);
            document.body.classList.remove('genderSliderVisible');
            document.body.classList.add('teamSliderVisible');
        });
    }

    let chooseGame = $('.js-show-game-slider');

    if (chooseGame) {
        chooseGame.addEventListener('click', () => {
            document.body.classList.remove('genderSliderVisible');
            document.body.classList.add('gameSliderVisible');
            _predict.updatedPredictedGames();
        });
    }


});

/*------------------------------------------------------------------
Start the app
------------------------------------------------------------------*/

document.addEventListener('DOMContentLoaded', () => {

    if ($('#MemberLoginForm_LoginForm_Email')) $('#MemberLoginForm_LoginForm_Email').setAttribute('placeholder', 'Your email');
    if ($('#MemberLoginForm_LoginForm_Password')) $('#MemberLoginForm_LoginForm_Password').setAttribute('placeholder', 'Password');

    if ($('#RegisterForm_RegisterForm_Name')) $('#RegisterForm_RegisterForm_Name').setAttribute('placeholder', 'Your name');
    if ($('#RegisterForm_RegisterForm_Email')) $('#RegisterForm_RegisterForm_Email').setAttribute('placeholder', 'Your email');
    if ($('#RegisterForm_RegisterForm_Password_Password')) $('#RegisterForm_RegisterForm_Password_Password').setAttribute('placeholder', 'Password');
    if ($('#RegisterForm_RegisterForm_Password_ConfirmPassword')) $('#RegisterForm_RegisterForm_Password_ConfirmPassword').setAttribute('placeholder', 'Confirm password');

    let $loginTab = $('.js-toggle-login');
    let $registerTab = $('.js-toggle-register');

    if ($loginTab) {
        $loginTab.addEventListener('click', () => {
            $loginTab.classList.add('active');
            $registerTab.classList.remove('active');
            $('.js-login').classList.add('active');
            $('.js-register').classList.remove('active');
        });
    }

    if ($registerTab) {
        $registerTab.addEventListener('click', () => {
            $registerTab.classList.add('active');
            $loginTab.classList.remove('active');
            $('.js-login').classList.remove('active');
            $('.js-register').classList.add('active');
        });
    }


    window.swipeversus = undefined;

    let createVersusSlider = () => {

        swipeversus = new Swiper('.js-slider-versus', {
            centeredSlides: true,
            effect: 'coverflow',
            navigation: {
                nextEl: '.swiper-button-next',
                prevEl: '.swiper-button-prev',
            },
            coverflowEffect: {
                rotate: 30,
                depth: 200,
                scale: 0.8,
            },
            loop: false,
            slidesPerView: 1.8,
            breakpoints: {
                768: {
                    slidesPerView: 3,
                }
            }

        });

        swipeversus.on('realIndexChange', function () {
            const sound = new Howl({
                src: [`${window.location.origin}/_resources/themes/mercury/dist/audio/whoosh.mp3`],
                volume: 0.2,
                html5: true
            });
            sound.play();
        });

    }

    let swipeGender = new Swiper('.js-slider-gender', {
        centeredSlides: true,
        effect: 'coverflow',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        coverflowEffect: {
            rotate: 30,
            depth: 200,
            scale: 0.8,
        },
        loop: false,
        slidesPerView: 1.8,
        breakpoints: {
            768: {
                slidesPerView: 3,
            }
        }

    });

    swipeGender.on('realIndexChange', function () {
        const sound = new Howl({
            src: [`${window.location.origin}/_resources/themes/mercury/dist/audio/whoosh.mp3`],
            volume: 0.2,
            html5: true
        });
        sound.play();
    });

    let swipe = new Swiper('.js-slider-team', {
        centeredSlides: true,
        effect: 'coverflow',
        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        coverflowEffect: {
            rotate: 30,
            depth: 200,
            scale: 0.8,
        },
        loop: false,
        slidesPerView: 1.8,
        breakpoints: {
            768: {
                slidesPerView: 3,
            }
        }
    });

    // on swipe change
    swipe.on('realIndexChange', function () {
        const sound = new Howl({
            src: [`${window.location.origin}/_resources/themes/mercury/dist/audio/whoosh.mp3`],
            volume: 0.2,
            html5: true
        });

        sound.play();
    })

    let initialSlideIndex = 0;

    // Find the index of the last slide with the data-availability of = 'past'
    const slides = document.querySelectorAll('.js-slider-game .swiper-slide');
    slides.forEach((slide, index) => {
        if (slide.dataset.availability === 'past') {
            initialSlideIndex = index;
        }
    });

    const goToFirstSlide = (division, availability) => {
        // Find the first slide with the given division and availability
        const firstSlide = document.querySelector(`.js-slider-game .swiper-slide[data-division="${division}"][data-availability="${availability}"]`);

        // If found, set it as the active slide
        if (firstSlide) {
            swipeGame.slideTo(Array.from(slides).indexOf(firstSlide), 0);

            swipeGame.init();
        } else {
            console.warn(`No slide found for division: ${division} and availability: ${availability}`);
        }


    }

    window.swipeGame = new Swiper('.js-slider-game', {
        centeredSlides: true,
        effect: 'coverflow',

        navigation: {
            nextEl: '.swiper-button-next',
            prevEl: '.swiper-button-prev',
        },
        initialSlide: initialSlideIndex + 1,
        coverflowEffect: {
            rotate: 30,
            depth: 200,
            scale: 0.8,
        },
        loop: false,
        slidesPerView: 1.8,
        breakpoints: {
            768: {
                slidesPerView: 3,
            }
        }

    });


    // on swipe change
    swipeGame.on('realIndexChange', function () {
        const sound = new Howl({
            src: [`${window.location.origin}/_resources/themes/mercury/dist/audio/whoosh.mp3`],
            volume: 0.2,
            html5: true
        });


        //get the current slide el
        const currentSlide = swipeGame.slides[swipeGame.activeIndex];

        if (currentSlide.dataset.availability !== 'current') {
            $('.js-start-predict').setAttribute('disabled', 'disabled');
        } else {
            $('.js-start-predict').removeAttribute('disabled');
        }


        sound.play();
    })

    let chooseVersus = $$('.js-show-versus-slider');

    chooseVersus.forEach((element) => {
        element.addEventListener('click', () => {

            const currentSlide = swipeGame.slides[swipeGame.activeIndex];
            const awayTeam = currentSlide.dataset.awayTeam;
            const homeTeam = currentSlide.dataset.homeTeam;
            const game_uid = currentSlide.dataset.uid;
            const division = currentSlide.dataset.division;

            _predict.startPredictGame(game_uid, division).then((data) => {


                if (swipeversus) swipeversus.destroy();

                $$('.js-slider-versus .js-team.swiper-slide').forEach(slide => {
                    slide.remove();
                });

                createVersusSlider();

                $$('.team-selector__slide').forEach(slide => {
                    if (slide.dataset.team === awayTeam || slide.dataset.team === homeTeam) {
                        swipeversus.appendSlide(slide.cloneNode(true));
                    }
                })

                swipeversus.update();

                document.body.classList.remove('teamSliderVisible');
                document.body.classList.remove('gameSliderVisible');
                document.body.classList.remove('genderSliderVisible');
                document.body.classList.add('versusSliderVisible');

            });


        });
    })


    /*------------------------------------------------------------------
    Intersection observers for animation styles
    ------------------------------------------------------------------*/

    const observer = new IntersectionObserver(entries => {
        entries.forEach(entry => {
            if (entry.isIntersecting) {
                entry.target.classList.add('inview');
                if (entry.target.classList.contains('js-confetti')) {
                    console.log('Confetti fired!');


                    var count = 400;
                    var defaults = {
                        origin: { y: 0.7 },
                        colors: [
                            '#E51F02',
                            '#FAF90C',
                            '#61062A',
                            '#3BF8F9',
                            '#07780B',
                            '#FD1BE7',
                            '#D7C586',
                        ]
                    };

                    function fire(particleRatio, opts) {
                        confetti({
                            ...defaults,
                            ...opts,
                            particleCount: Math.floor(count * particleRatio)
                        });
                    }

                    fire(0.25, {
                        spread: 26,
                        startVelocity: 55,
                    });
                    fire(0.2, {
                        spread: 60,
                    });
                    fire(0.35, {
                        spread: 100,
                        decay: 0.91,
                        scalar: 0.8
                    });
                    fire(0.1, {
                        spread: 120,
                        startVelocity: 25,
                        decay: 0.92,
                        scalar: 1.2
                    });
                    fire(0.1, {
                        spread: 120,
                        startVelocity: 45,
                    });
                }
            }
        });
    }, {
        root: null, // Use the viewport as the root
        rootMargin: '-35% 0px' // Trigger when the element is in the middle of the page
    });

    // Add the observer to all elements with the class `js-inview`
    setTimeout(() => $$('.js-inview').forEach(element => observer.observe(element)), 10);


    /*------------------------------------------------------------------
    Sliders
    ------------------------------------------------------------------*/

    if ($('.embla')) {
        import('@/components/slider')
            .then(module => $$('.embla').forEach(element => new module.Slider(element)))
            .catch(error => console.error("Slider video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Banner Video
    ------------------------------------------------------------------*/

    if ($('.js-banner-video')) {
        import('@/components/banner-video')
            .catch(error => console.error("Banner video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Accordion Elements
    ------------------------------------------------------------------*/

    if ($('.js-accordion-element')) {
        import('@/components/accordion')
            .then(module => $$('.js-accordion-element').forEach(element => new module.Accordion(element)))
            .catch(error => console.error("Accordion component failed to load", error));
    }


    /*------------------------------------------------------------------
    Video Elements
    ------------------------------------------------------------------*/

    if ($('.js-video-element')) {
        import('@/components/video')
            .then(module => $$('.js-video-element').forEach(element => new module.Video(element)))
            .catch(error => console.error("Video component failed to load", error));
    }


    /*------------------------------------------------------------------
    Post Load classname removal:
    This removes the class `js-postload` from elements after the page 
    has loaded, to prevent any unwanted animations.
    ------------------------------------------------------------------*/

    $$('.js-postload').forEach(element => {
        element.classList.remove('js-postload');
    });


    /*------------------------------------------------------------------
    Sticky header:
    It hides/shows the header when scrolling up and down
    ------------------------------------------------------------------*/

    // Initialize the previous scroll position to 0
    let previousScrollPosition = 0;

    // Define the scroll delta to determine significant scroll changes
    const scrollDelta = 5;

    // Select the header element
    const header = document.querySelector('.header');

    // Calculate the header height, defaulting to 0 if the header is not found
    const headerHeight = header ? header.clientHeight / 3 : 0;

    /**
     * Function to handle the sticky header behavior based on scroll position.
     */
    const stickyHeader = () => {
        // If no header is found, exit the function
        if (!header) return;

        document.body.classList.remove('menu-open');


        // Get the current scroll position
        let currentScroll = window.scrollY;

        // If the scroll change is less than the defined delta, exit the function
        if (Math.abs(previousScrollPosition - currentScroll) <= scrollDelta) return;

        // If at the top of the page, remove any navigation classes
        if (currentScroll === 0) {
            header.classList.remove('nav-down', 'nav-up');
        }
        // If scrolling down and past the header height, hide the header
        else if (currentScroll > previousScrollPosition && currentScroll > headerHeight) {
            header.classList.remove('nav-down');
            header.classList.add('nav-up');
        }
        // If scrolling up and not at the bottom of the page, show the header
        else {
            if (currentScroll + window.innerHeight < document.body.clientHeight) {
                header.classList.add('nav-down');
                header.classList.remove('nav-up');
            }
        }

        // Update the previous scroll position
        previousScrollPosition = currentScroll;

    };

    // Use requestAnimationFrame for smoother scroll event handling
    let isScrolling = false;

    // Add a scroll event listener to the window
    window.addEventListener('scroll', () => {
        // If not already scrolling, use requestAnimationFrame to call stickyHeader
        if (!isScrolling) {

            window.requestAnimationFrame(() => {
                stickyHeader();
                isScrolling = false;
            });

            isScrolling = true;
        }
    });
});
